import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const UnitRegex = /^UA|^UB|^UC|^UD/;
export const SparepartRegex = /^SH|^SG|^SF|^SE|^SD|^SC|^SB|^SA|^LC|^LB|^LA/;

export { copyToClipboard } from './utils/utils';
